export default "/images/select_opt1_ad_creative.gif?987c0c92f4be9f0b15997e040b9b4f83";